<div class="course-preview-header">
  <div class="header-row">
    <div class="header-text">
      <div class="top-line">
        <i class="bi bi-arrow-left-short" (click)="goBack()"></i>
        <h3 class="course-heading fw-bold">Course Details</h3>
      </div>
    </div>
  </div>
  <div class="divider"></div>
</div>

<div *ngIf="_syllabusData; else noCourse">

  <!-- Course Details -->
  <div class="course-details-card">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-mortarboard-fill text-light"></i></div>
      <div class="course-details-title">
        Course Details
        <div class="course-details-subtitle">Basic information</div>
      </div>
    </div>
    <div class="course-details-content">
      <div class="course-details-row">
        <div class="course-details-col">
          <div class="course-details-label">COURSE NAME</div>
          <div class="course-details-value">{{ _syllabusData.course_title || '-' }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">COURSE CODE</div>
          <div class="course-details-value">{{ _syllabusData.course_code || '-' }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">GRADE LEVEL</div>
          <div class="course-details-value">{{ _syllabusData.grade_level || '-' }}</div>
        </div>
      </div>
      <div class="course-details-row">
        <div class="course-details-col">
          <div class="course-details-label">CREDITS</div>
          <div class="course-details-value">{{ _syllabusData.credits || 0 }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">CIE MARKS</div>
          <div class="course-details-value">{{ _syllabusData.internal_marks || 0 }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">SIE MARKS</div>
          <div class="course-details-value">{{ _syllabusData.exam_marks || 0 }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Course Objectives -->
  <div class="course-details-card" *ngIf="_syllabusData.course_objectives?.length">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-bullseye text-light"></i></div>
      <div class="course-details-title">
        Course Objectives
        <div class="course-details-subtitle">What students will learn</div>
      </div>
    </div>
    <div class="course-details-content">
      <ul>
        <li *ngFor="let objective of _syllabusData.course_objectives">{{ objective }}</li>
      </ul>
    </div>
  </div>

  <!-- Units -->
  <div class="course-details-card" *ngIf="_syllabusData.units?.length">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-book text-light"></i></div>
      <div class="course-details-title">
        Units
        <div class="course-details-subtitle">Units, topics, and subtopics</div>
      </div>
    </div>
    <div class="course-details-content">
      <div class="unit-card" *ngFor="let unit of _syllabusData.units">
        <div class="unit-header">
          <div class="unit-title-row">{{ unit.unit_title || '-' }}</div>
          <div class="unit-duration">Duration: {{ unit.unit_hours || 0 }} hours</div>
        </div>
        <div class="unit-topics" *ngIf="unit.topics?.length">
          <div class="topic" *ngFor="let topic of unit.topics">
            <span class="dot"></span> {{ topic.topic_title || '-' }}
            <div class="subtopic" *ngFor="let sub of topic.subtopics || []">
              <span class="sub-dot"></span> {{ sub.subtopic_title|| '-' }} 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Course Outcomes -->
  <div class="course-details-card" *ngIf="_syllabusData.course_outcomes?.length">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-award-fill text-light"></i></div>
      <div class="course-details-title">
        Course Outcomes
        <div class="course-details-subtitle">Expected results</div>
      </div>
    </div>
    <div class="course-details-content">
      <ul>
        <li *ngFor="let outcome of _syllabusData.course_outcomes">{{ outcome }}</li>
      </ul>
    </div>
  </div>

  <!-- Textbooks & Web Resources -->
  <div class="course-details-card"
    *ngIf="_syllabusData.textbooks?.length || _syllabusData.web_references_links?.length">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-cart-fill text-light"></i></div>
      <div class="course-details-title">
        Resources & References
        <div class="course-details-subtitle">Textbooks and web resources</div>
      </div>
    </div>
    <div class="course-details-content">

      <!-- Textbooks -->
      <div class="resource-row" *ngIf="_syllabusData.textbooks?.length">
        <div class="resource-title">Textbooks</div>
        <div class="resource-card" *ngFor="let book of _syllabusData.textbooks; let i = index">
          <div class="resource-name-row">
            <span class="resource-count">{{ i + 1 }}</span>
            <span class="resource-name">{{ book.title || '-' }}</span>
          </div>
          <div class="resource-details">
            <span class="resource-author">{{ book.author || '-' }} | {{ book.publisher || '-' }} {{ book.year ? ', ' +
              book.year : '' }}</span>
          </div>
        </div>
      </div>

      <!-- Web Resources -->
      <div class="resource-row" *ngIf="_syllabusData.web_references_links?.length">
        <div class="resource-title">Web Resources</div>
        <div class="resource-card" *ngFor="let resource of _syllabusData.web_references_links; let i = index">
          <div class="resource-name-row">
            <span class="resource-count">{{ i + 1 }}</span>
            <a [href]="resource" target="_blank">{{ resource }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #noCourse>
  <p class="text-center text-muted">No Course Data Available</p>
</ng-template>